import script from "./ArticleDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./ArticleDetailComponent.vue?vue&type=style&index=0&id=28f5a72c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f5a72c"]])

export default __exports__